import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import UnitImage from "common/src/tft-static/UnitImage";
// import { make as UnitImageExtended } from "common/src/tft-static/UnitImageExtended.bs";
import ItemImage from "common/src/tft-static/ItemImage";
import AugmentImage from "common/src/tft-static/AugmentImage";
import { PlainIcon } from "common/src/tft-static/TraitImage";
import { css } from "@emotion/css";
import React from "react";
import { Filter } from "./CoQuery";
// import InfoIcon from "@mui/icons-material/InfoOutlined";
import { ListboxComponent } from "../components/BaseAutocomplete";

type Props = {
  inputId: string;
  options: Array<Filter>;
  onChange: (v: Filter | undefined) => void;
  value?: Filter;
  placeholder?: string;
  getMatches: (search: string) => Array<Filter>;
  disabled?: boolean;
};

const CoAutocomplete = ({
  inputId,
  options,
  onChange,
  value,
  placeholder = undefined,
  getMatches,
  disabled,
}: Props) => {
  const startAdornment = React.useCallback((v: Filter) => {
    if (v.typ == "u") {
      return <UnitImage unitId={v.id} size={28} />;
    } else if (v.typ == "t") {
      const adjRank = Number(v.rank.replace(/\+|-/, ""));
      return <PlainIcon traitId={v.id} size={28} rank={adjRank} />;
    } else if (v.typ == "i") {
      return <ItemImage itemId={v.id} size={28} rounded="rounded" />;
    } else if (v.typ == "a") {
      return <AugmentImage augId={v.id} size={28} />;
    }
  }, []);

  const renderOption = React.useCallback((props: any, v: Filter) => {
    let el = null;
    if (v.typ == "u") {
      el = <UnitImage unitId={v.id} size={28} />;
    } else if (v.typ == "t") {
      const adjRank = Number(v.rank.replace(/\+|-/, ""));
      el = <PlainIcon traitId={v.id} size={28} rank={adjRank} />;
    } else if (v.typ == "i") {
      el = <ItemImage itemId={v.id} size={28} rounded="rounded" />;
    } else if (v.typ == "a") {
      el = <AugmentImage augId={v.id} size={28} />;
    }

    return (
      <div key={v.label} {...props}>
        {el}
        <span className="font-montserrat leading-tight font-medium inline text-base pl-[6px]">
          {v.label}
        </span>
      </div>
    );
  }, []);

  return (
    <Autocomplete
      disabled={disabled}
      sx={{ width: 250 }}
      classes={{
        popper: css({ minWidth: "275px" }),
      }}
      value={value}
      onChange={(_, v: Filter | null) => onChange(v || undefined)}
      filterOptions={(vs, state) => {
        if (state.inputValue) {
          return getMatches(state.inputValue);
        } else {
          return vs;
        }
      }}
      // @ts-ignore
      ListboxComponent={ListboxComponent}
      options={options}
      renderOption={renderOption}
      autoHighlight
      renderInput={(params) => {
        return (
          <TextField
            placeholder={placeholder}
            {...params}
            inputProps={{
              ...params.inputProps,
              // @ts-ignore
              value: params.inputProps.value
                ? // @ts-ignore
                  params.inputProps.value
                : value?.label || "",
            }}
            variant="standard"
            InputProps={{
              ...params.InputProps,
              classes: {
                input: `font-montserrat font-medium ${inputId}`,
              },
              startAdornment: (
                <InputAdornment position="start">
                  {value && startAdornment(value)}
                </InputAdornment>
              ),
            }}
          />
        );
      }}
    />
  );
};

export default CoAutocomplete;
